/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordrequired1Inputs */

const en_passwordrequired1 = /** @type {(inputs: Passwordrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password is required`)
};

const de_passwordrequired1 = /** @type {(inputs: Passwordrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Password is required" |
*
* @param {Passwordrequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordrequired1 = /** @type {((inputs?: Passwordrequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordrequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordrequired1(inputs)
	return de_passwordrequired1(inputs)
});
export { passwordrequired1 as "passwordRequired" }